import * as Sentry from '@sentry/react';
import { extractComponentFromErrorStack, extractFilePath, extractErrorDetails } from '../utils/errorParsing';
import { addCompleteContextToSentry } from '../contexts/sentryContext';
import { ViewContext } from '../types/errorTypes';

export function handleJavaScriptError(
  event: ErrorEvent,
  getViewContext: () => ViewContext
): void {
  const { error, filename, lineno, colno, message } = event;

  Sentry.withScope((scope) => {
    scope.setTag('errorType', 'javascript');
    scope.setLevel('error');
    
    const viewContext = getViewContext();
    scope.setContext('view', viewContext);
    
    const componentFromError = error ? extractComponentFromErrorStack(error.stack) : null;
    const filePath = error ? extractFilePath(error.stack) : null;
    const detectedComponent = componentFromError || 'Unknown';
    
    if (componentFromError) {
      scope.setTag('component', componentFromError);
      console.log('📍 Component detected from error:', componentFromError);
    }
    
    if (filePath) {
      scope.setTag('file', filePath);
    }
    
    scope.setContext('errorEvent', {
      filename,
      lineno,
      colno,
      message,
      timestamp: new Date().toISOString(),
      detectedComponent,
      filePath
    });

    if (error) {
      const errorDetails = extractErrorDetails(error);
      scope.setContext('errorDetails', errorDetails);
    }

    addCompleteContextToSentry(scope);

    if (error && error instanceof TypeError) {
      scope.setTag('errorCategory', 'typeError');
      scope.setContext('typeError', {
        name: error.name,
        message: error.message,
        stack: error.stack
      });
    }

    if (message.includes('Loading chunk') || message.includes('ChunkLoadError')) {
      scope.setTag('errorCategory', 'chunkLoadError');
      scope.setContext('chunkLoadError', {
        message,
        filename,
        timestamp: new Date().toISOString()
      });
    }

    Sentry.captureException(error || new Error(message));
  });
}

